var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfocar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "informasjon om bil",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92571 6.02515C4.04327 6.02515 3.3079 6.5867 3.02712 7.37555L0.246094 15.3844V26.0807C0.246094 26.816 0.847759 27.4177 1.58313 27.4177H2.92016C3.65553 27.4177 4.25719 26.816 4.25719 26.0807V24.7436H20.3016V26.0807C20.3016 26.816 20.9033 27.4177 21.6386 27.4177H22.9757C23.711 27.4177 24.3127 26.816 24.3127 26.0807V15.3844L22.4858 10.3078L19.6354 10.5848L20.5423 12.7103H4.00316L5.39367 8.69921H16.6933L16.0191 6.02515H4.92571ZM4.25719 18.727C4.25719 19.8367 5.15301 20.7325 6.26274 20.7325C7.37248 20.7325 8.2683 19.8367 8.2683 18.727C8.2683 17.6172 7.37248 16.7214 6.26274 16.7214C5.15301 16.7214 4.25719 17.6172 4.25719 18.727ZM16.2905 18.727C16.2905 19.8367 17.1863 20.7325 18.296 20.7325C19.4058 20.7325 20.3016 19.8367 20.3016 18.727C20.3016 17.6172 19.4058 16.7214 18.296 16.7214C17.1863 16.7214 16.2905 17.6172 16.2905 18.727Z",
    fill: "#016CC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7649 10.712C23.5454 10.712 25.7994 8.45798 25.7994 5.67753C25.7994 2.89707 23.5454 0.643066 20.7649 0.643066C17.9844 0.643066 15.7304 2.89707 15.7304 5.67753C15.7304 8.45798 17.9844 10.712 20.7649 10.712ZM21.3494 8.28375H20.1941V4.58551H21.3494V8.28375ZM20.3035 3.22857C20.185 3.33339 20.1257 3.46783 20.1257 3.63189C20.1257 3.79596 20.185 3.9304 20.3035 4.03521C20.422 4.14003 20.5758 4.19244 20.7649 4.19244C20.954 4.19244 21.1078 4.14003 21.2263 4.03521C21.3448 3.9304 21.4041 3.79596 21.4041 3.63189C21.4041 3.46783 21.3448 3.33339 21.2263 3.22857C21.1078 3.12376 20.954 3.07135 20.7649 3.07135C20.5758 3.07135 20.422 3.12376 20.3035 3.22857Z",
    fill: "#016CC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfocar);
export default __webpack_public_path__ + "static/media/infocar.3e7c57b9.svg";
export { ForwardRef as ReactComponent };